var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.type},[_c('div',{staticClass:"partition"},[_c('div',{style:(_vm.pattern)})])])}
var staticRenderFns = []

export { render, staticRenderFns }